module.exports = __webpack_public_path__ + "img/arrow-right-green.6a8a29d7.svg";